<template>
	<div class="review-topics">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page content-subProject">
					<div class="content">
						<!-- <div class="row">
              <div class="col-12">
                <div class="page-title-box">
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a href="javascript: void(0);">首页</a></li>
                      <li class="breadcrumb-item">课题申报</li>
                      <li class="breadcrumb-item"><a href="javascript: void(0);">专家评分</a></li>
                      <li class="breadcrumb-item">待评审课题</li>
                      <li class="breadcrumb-item active">待评审课题详情</li>
                    </ol>
                  </div>
                  <h3 class="header-title mb-3">待评审课题详情</h3>
                </div>
              </div>
            </div> -->
						<div class="row mb-1">
							<div class="col-xl-6">待评审课题详情</div>
							<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
						</div>
						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="card-reviewDetails">
											<h3 class="text-center">课题名称：{{ detail.declareName }}</h3>
											<div class="row row-reviewDetails">
												<div class="col-6 col-md-3">研究领域：{{ detail.researchFieName }}</div>
												<div class="col-6 col-md-3">预期成果：{{ detail.expectedResearchResults }}</div>
												<div class="col-6 col-md-3">学段：{{ detail.learningTypeName }}</div>
												<div class="col-6 col-md-3">结题时间：{{ detail.expectedClosingTime }}</div>
											</div>
											<div class="nav-conForm mb-4">
												<!-- <img src="@/assets/images/projects/project-1.jpg" alt=""> -->
												<!-- <a :href="uploadUrl+'/upload/download?openStyle=1&id='+'140'">aaaa</a> -->
												<!-- 在线浏览文档 -->
												<div class="view"><iframe ref="myIframe" height="100%" width="100%"></iframe></div>
											</div>

											<div class="table-responsive">
												<table class="table table-hover table-bordered table-centered table-proApp">
													<thead>
														<tr>
															<th class="text-center">评分标准</th>
															<th class="text-center">评分标准说明</th>
															<th class="text-center">分值</th>
															<th class="text-center" style="min-width: 100px;">得分</th>
														</tr>
													</thead>

													<tbody>
														<tr v-for="item in detail.scoringCriteriaList" :key="item.id">
															<td class="text-center">{{ item.name }}</td>
															<td>{{ item.note }}</td>
															<td class="text-center">{{ item.score }}</td>
															<td class="text-center"></td>
														</tr>
														<tr>
															<th class="text-right" colspan="2">总分</th>
															<td class="text-center">{{ detail.totalScore }}</td>
															<td class="text-center">
																<el-popover placement="right" title="提示" width="200" trigger="manual" :content="scoreVisibleText" v-model="scoreVisible">
																	<el-input v-model.number="updateForm.score" slot="reference" type="number" min="0" max="50" @input="scoreInputChange"></el-input>
																</el-popover>
															</td>
														</tr>
													</tbody>
												</table>
											</div>
											<!--表单 -->
											<el-form :model="updateForm" :rules="rules" ref="ruleForm" label-width="100px" :validate-on-rule-change="true">
												<el-form-item label="评审结果：" prop="type">
													<el-radio-group v-model="updateForm.type" @change="typeChange">
														<el-radio :label="item.id" v-for="(item) in reviewResultOptions" :key="item.id">{{item.name}}</el-radio>
													</el-radio-group>
												</el-form-item>
													<el-form-item label="评分附件："  >
													
												<a @click="downloadFile">{{detail.annexName}}</a>
							
												</el-form-item>
												<el-form-item label="专家评语：" prop="note"><el-input type="textarea" v-model="updateForm.note"></el-input></el-form-item>
												<el-form-item class="mt-3 " style="text-">
													<el-button type="primary" @click="onSubmit">保存</el-button>
													<el-button type="primary" @click="onSubmit('next')">保存并下一个</el-button>
													<el-button @click="toNotReviewTopics">返回</el-button>
												</el-form-item>
											</el-form>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
// import { getDeclareInfoByGroupIdAndDeclareId, saveOrUpdateExpertsScore, getExpertScoreAuditList } from '@/api/after/expertScore';
import { getReviewTopicDeatil,saveOrEditExpertScore,getReviewTopicList } from '@/api/after/topicManage.js'
import { getPlatformInformationData } from '@/api/after/systemManagement';
import { fileLook } from '@/api/public';
export default {
	name: 'notReviewTopicsDetail',
	components: { Breadcrumb },
	data() {
		return {
			scoreVisible: false,
			scoreVisibleText: '分数不能小于0',
			subjectData: {}, //课题信息
			//  课题详情
			detail: {
				id: 1,
				name: '以戏剧为主要形式的小学英语课堂研究',
				keywords: '关键字1,关键字2,关键字3',
				projectTypeId: 24,
				projectTypeName: '思想品德',
				learningType: 1,
				learningTypeName: '小学',
				disciplineId: 2,
				disciplineName: '英语',
				researchFieId: 3,
				researchFieName: '综合研究',
				expectedResearchResults: '3',
				expectedClosingTime: '2021-06-30 14:41:00',
				oneEmceeId: 1,
				oneEmceeName: 'admin',
				gender: 1,
				nation: '汉族',
				birthTime: '1999-01-01 11:44:00',
				administrativeDuties: '行政职务',
				professionalSkillPostId: 10,
				professionalSkillPostName: null,
				areasSpecialization: '教学研究',
				lastDegreeId: '12',
				lastQualificationId: '14',
				phone: '17608001347',
				unitId: 1,
				unitName: '庐山小学',
				email: '1191738666@qq.com',
				address: '北京市',
				postalCode: '610000',
				twoEmceeId: 2,
				twoEmceeName: 'kefu',
				coreMember: '1,2,3',
				declarationContents: '',
				anonymousReview: '',
				type: 23,
				version: 5,
				createTime: '2021-03-08 14:47:46',
				updateTime: '2021-03-18 20:06:14',
				projectId: 1,
				coreMemberName: 'admin,kefu,测算',
				scoringCriteriaList: [
					{
						id: 1,
						name: '选题的意义',
						note: '不知道',
						score: 20,
						groupId: 1,
						version: 0,
						createTime: null,
						updateTime: null
					},
					{
						id: 2,
						name: '研究基础',
						note: '不清楚',
						score: 15,
						groupId: 1,
						version: 0,
						createTime: null,
						updateTime: null
					},
					{
						id: 3,
						name: '课题设计',
						note: '设计情况',
						score: 40,
						groupId: 1,
						version: 0,
						createTime: null,
						updateTime: null
					},
					{
						id: 4,
						name: '研究方法',
						note: '随便写',
						score: 15,
						groupId: 1,
						version: 0,
						createTime: null,
						updateTime: null
					},
					{
						id: 5,
						name: '研究条件',
						note: '没有',
						score: 10,
						groupId: 1,
						version: 0,
						createTime: null,
						updateTime: null
					}
				],
				totalScore: 100,
				expertsScoreId: 1,
				score: 1,
				expertsScoreType: 1,
				note: null
			},
			updateForm: {
				// projectManagementId:'',//课题管理id			
				// projectManagementName:'',//课题管理名称			
				// settingId:'',//设置id			
				// userId:'',//专家id			
				// groupId:'',//评审组id			
				// groupName:'',//评审组名称			
				// userName:'',//专家姓名			
				score:'',//分数			
				type:'',//类型id			
				note:'',//专家评语			
				// createTime:'',//创建时间			
				// updateTime:'',//更新时间			
				// isSubmit:'',//是否提交评审(0:未提交,1:已提交)			
				// reviewType:'',//评审类型(0:初评,1:复评,2:终评)			
				typeName:'',//类型名称
				id: 0,
			},
			rules: {
				type: [{ required: true, message: '请选择立项建议', trigger: 'change' }],
				note: [{ message: '请输入评语', trigger: 'change' }]
			},
			query: {
				expertsScoreId:'',//评分id
				projectManagementId:'',//课程管理id		
				settingId:'',//设置id
			},
			reviewResultOptions:[],//评审结果列表
		};
	},
	mounted() {
		let data = JSON.parse(this.$route.query.data)
		console.log('传递过来的数据',data);
		if (data) {
			this.subjectData = data
			this.query = {
				expertsScoreId:this.subjectData.id,//评分id
				projectManagementId:this.subjectData.projectManagementId,//课程管理id		
				settingId:this.subjectData.settingId,//设置id
			}
			if (this.subjectData.type) {
				this.updateForm.type = +this.subjectData.type;
				this.updateForm.score = this.subjectData.score;
				this.updateForm.note = this.subjectData.note;
			}
		}else{
			this.$message.error(res.data)
		}
		console.log(this.subjectData);
		this.getReviewResult()
	},
	watch: {
		$route() {
			console.log('参数', JSON.parse(this.$route.query.data));
			this.subjectData = this.$route.query.data ? JSON.parse(this.$route.query.data) : {};
			this.query = {
				expertsScoreId:this.subjectData.id,//评分id
				projectManagementId:this.subjectData.projectManagementId,//课程管理id		
				settingId:this.subjectData.settingId,//设置id
			}
			if (this.subjectData.type) {
				this.updateForm.type = +this.subjectData.type;
				this.updateForm.score = this.subjectData.score;
				this.updateForm.note = this.subjectData.note;
			} else {
				this.updateForm.type = '';
				this.updateForm.score = '';
				this.updateForm.note = '';
			}
		},
		subjectData(val) {
			this.query = {
				expertsScoreId:val.id,//评分id
				projectManagementId:val.projectManagementId,//课程管理id		
				settingId:val.settingId,//设置id
			}
			this.getData();
		}
	},
	methods: {
		// 获取评审结果数据
		async getReviewResult(){
			const res = await getPlatformInformationData(10)
			if (res.code == 200) {
				console.log('评审结果信息',res);
				this.reviewResultOptions = res.data
			}else{
				this.$message.error(res.data)
			}
		},
		// 获取数据
		getData() {
			getReviewTopicDeatil(this.query).then(res => {
				if (res.code == 200) {
					console.log('当前详情', res);
					this.detail = res.data;
					// 回显数据
					this.updateForm = {
						score:this.detail.score,//分数
						type:this.detail.type,//类型id			
						note:this.detail.note,//专家评语	
						typeName:this.detail.typeName,//类型名称
						id: this.subjectData.id,
					}
					this.fileLook(this.detail.materials.annex);
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取数据列表
		fileLook(id) {
			fileLook(id).then(res => {
				if (res.code == 200) {
					console.log(res);
					this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${res.data.id}`);
				} else {
					this.$message.error(res.data);
				}
			});
		},
		scoreInputChange(val) {
			console.log(val);
			if (val === '') {
				this.scoreVisibleText = '得分不能为空';
				this.scoreVisible = true;
			} else {
				let num = +val;
				if (num < 0) {
					this.scoreVisibleText = '得分不能小于0';
					this.scoreVisible = true;
				} else if (num > this.detail.totalScore) {
					this.scoreVisibleText = '得分不能大于总分' + this.detail.totalScore;
					this.scoreVisible = true;
				} else {
					this.scoreVisible = false;
				}
			}
		},
		typeChange(val) {
			console.log('评审结果',val);
			let reviewResultObj = this.reviewResultOptions.find(item=>{
				return item.id == val
			})
			this.updateForm.typeName = reviewResultObj.name
			// if (val === 0) {
			// 	this.rules.note.push({
			// 		required: true,
			// 		message: '请输入评语',
			// 		trigger: 'change'
			// 	});
			// } else {
			// 	this.rules.note = [];
			// }
		},
		onSubmit(type) {
			if (this.updateForm.score === '') {
				this.$message.error('得分不能为空');
				return;
			}
			let score = +this.updateForm.score;
			if (score < 0 || score > this.detail.totalScore) {
				this.$message.error('得分输入不正确，请修改后保存');
				return;
			}
			this.$refs.ruleForm.validate(valid => {
				if (valid) {
					if (type == 'next') {
						this.saveOrEditExpertScore('next');
					} else {
						this.saveOrEditExpertScore();
					}
				} else {
					return false;
				}
			});
		},
		// 评分
		saveOrEditExpertScore(type) {
			console.log('上传评审参数',this.updateForm);
			saveOrEditExpertScore(this.updateForm).then(res => {
				if (res.code == 200) {
					this.$message.success('保存成功');
					if (type == 'next') {
						this.getExpertScoreAuditList();
					} else {
						// 返回上一步
						this.toNotReviewTopics();
					}
				} else {
					this.$message.error(res.data);
				}
			});
		},
		// 获取待评审列表
		async getExpertScoreAuditList() {
			
			let params = {
				isSubmit:0,//是否提交评审(0:未提交)
				pageNumber:1,//页码,默认为1,示例值(1)			
				pageSize:10,//页大小,默认为10,示例值(10)			
				settingId:this.subjectData.settingId,//课题管理设置id
			}
			const res = await getReviewTopicList(params)
			if (res.code == 200) {
				if (res.data.records.length>0) {
					this.subjectData = res.data.records[0]
				}else{
					this.$message.info('没有待评审的课题了！')
					this.$router.go(-1)
				}
			}else{
				this.$message.error(res.data)
			}
			// let userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
			// let query = {
			// 	userId: userInfo.id,
			// 	groupId: this.subjectData.groupId,
			// 	isSubmit: 0,
			// 	pageNumber: 1,
			// 	pageSize: 10
			// };
			// getExpertScoreAuditList(query).then(res => {
			// 	if (res.code == 200) {
			// 		let list = res.data.records;
			// 		if (list && list.length > 0) {
			// 			this.$router.replace({
			// 				path: '/backstage/notReviewTopicsDetail',
			// 				query: { data: JSON.stringify(list[0]) }
			// 			});
			// 		} else {
			// 			this.$message.error('当前项目没有待评课题');
			// 			this.$router.push('/backstage/expertScoreList');
			// 		}
			// 	} else {
			// 		this.$message.error(res.data);
			// 	}
			// });
		},
		toNotReviewTopics() {
			this.$router.go(-1);
		},

		//下载文件
			downloadFile(){
				let id =this.detail.annexId;

				window.open(`${this.uploadUrl}/upload/download?id=${id}&openStyle=1`, '_blank');
				// console.log(data);
				// downloadFile(data).then((res)=>{

				// }).catch((err)=>{

				// });
			},
	}
};
</script>

<style scoped>
.view {
	width: 1000px;
	height: 500px;
}
</style>
